<template>
    <div class="o-alerts">
        <o-list
            vuex-action-fetch="fetchAlertsForUser"
            vuex-action-fetch-next-page="fetchAlertsForUserNextPage"
            vuex-getter-model="alertsForUser"
            vuex-getter-status="alertsForUserStatus"
            router-single-name="alert"
        >
            <template slot="list" slot-scope="props">
                <p class="m-list__itemTitle m-list__itemTitle--bold">
                    {{ `Alert ${props.list.item.id}` }}
                </p>
                <p class="m-list__itemDate">
                    {{ $dayjs(props.list.item.created_at).format('DD.MM.YYYY, HH:mm:ss') }}
                </p>
                <div class="m-list__itemHeader">
                    <div
                        v-if="props.list.item.agrofags && props.list.item.agrofags.length > 0"
                        class="m-list__itemHeaderCell"
                    >
                        <a-icon
                            class="m-list__icon m-list__icon--header"
                            icon="AgrofagSmall"
                        />
                        {{ props.list.item.agrofags[0].name }}
                        <template v-if="props.list.item.agrofags.length > 1"><br />i inne</template>
                    </div>
                    <div
                        v-if="props.list.item.crops && props.list.item.crops.length > 0"
                        class="m-list__itemHeaderCell"
                    >
                        <a-icon
                            class="m-list__icon m-list__icon--header"
                            icon="CropSmall"
                        />
                        {{ props.list.item.crops[0].name }}
                        <template v-if="props.list.item.crops.length > 1"><br />i inne</template>
                    </div>
                    <div
                        v-if="props.list.item.counties && props.list.item.counties.length > 0"
                        class="m-list__itemHeaderCell"
                    >
                        <a-icon
                            class="m-list__icon m-list__icon--header"
                            icon="RegionSmall"
                        />
                        {{ props.list.item.counties[0].name }}
                        <template v-if="props.list.item.counties.length > 1"><br />i inne</template>
                    </div>
                </div>
                <div
                    v-if="props.list.item.description_trunc"
                    class="m-list__itemDescription"
                >
                    {{ props.list.item.description_trunc }}
                </div>
            </template>
        </o-list>
    </div>
</template>

<script>
export default {
    metaInfo: {
        title: 'Powiadomienia'
    }
}
</script>
